import React from 'react';

export function Footer() {
  return (
    <footer className="footer">
      <div><strong>《弹球砖块破坏者1.0》</strong> · VIVA原创网页游戏</div>
      <div>© 2026 VIVA 游戏实验室 ｜ <a href="https://viva.net.cn" target="_blank" rel="noreferrer">viva.net.cn</a></div>
    </footer>
  );
}
